module.exports = __webpack_public_path__ + "img/product-x2.dd30ace6.jpg";